<template>
  
    <article class="blog__latest-item d-flex">
        <a :href="articleLink" class="blog__latest-header" :style="mainImage"></a>
        <div class="blog__latest-body d-flex flex-column justify-content-between">
            <div class="blog__latest-heading">
                <article-meta :article="article" />
                <h3 class="blog__latest-title">
                    <a :href="articleLink" v-text="article.title"></a>
                </h3>
            </div>
            <article-media-nav class="blog__latest-media" v-bind="mediaProps" />
        </div>
    </article>

</template>

<script>

import ArticleMeta from './ArticleMeta.vue'
import ArticleMediaNav from './ArticleMediaNav.vue'

export default {
    name: "LatestArticle",
    components: { ArticleMeta, ArticleMediaNav },

    props: {
        article: {
            required: true,
            type: Object
        }
    },

    computed: {

        mainImage(){
            let { path } = this.article.main_image
            return {
                backgroundImage: (`url('/storage/${path}')`).replace( 'original', 'preview' )
            }
        },

        articleLink(){
            let { slug } = this.article
            let category = this.article.category.slug
            return `/blog/${category}/${slug}`
        },

        mediaProps(){
            let { comments_count, follow, id: post_id } = this.article

            return{
                post_id,
                follow,
                comments_count,
                link: this.articleLink
            }
        },

    }

}
</script>

<style>

</style>